module.exports = __webpack_public_path__ + "img/electrica.c025e090.jpeg";